module.exports = __webpack_public_path__ + "img/agree.ee0d59c8.png";